import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayerFilter from "./PlayerFilter";
import ScoutFilter from "./ScoutFilter";
import CoachFilter from "./CoachFilter";
import OtherFilter from "./OtherFilter";
import AgentFilter from "./AgentFilter";
import { useState } from "react";
import { entityRoleEnum } from "../../../enums/entity.enum";
import { AdvancedFilters, AgentFilters, CoachFilters, OtherFilters, PlayerFilters, ScoutFilters } from "../../../types";
import { colors } from "../../../theme/palette";
import typography from "../../../theme/typography";
import { useTranslation } from "react-i18next";

const AdvancedSearch = ({
  entityRole,
  openAdvancedSearch,
  closeAdvancedSearch,
  networkFilters,
  setNetworkFilters,
  advancedFilters,
  setAdvancedFilters,
}: {
  entityRole: string | entityRoleEnum | null;
  openAdvancedSearch: boolean;
  closeAdvancedSearch: () => void;
  networkFilters: {};
  setNetworkFilters: React.Dispatch<React.SetStateAction<{}>>;
  advancedFilters: {};
  setAdvancedFilters: React.Dispatch<React.SetStateAction<{}>>;
}) => {
  const { t } = useTranslation();

  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const applyFilter = () => {
    setNetworkFilters(advancedFilters);
    closeAdvancedSearch();
  };
  const clearFilter = () => {
    setNetworkFilters({} as AdvancedFilters);
    setAdvancedFilters({} as AdvancedFilters);
    setIsFilterCleared((prev) => !prev);
  };

  let content;
  switch (entityRole?.toUpperCase()) {
    case "PLAYER":
      content = (
        <PlayerFilter
          advancedFilters={advancedFilters as PlayerFilters}
          setAdvancedFilters={setAdvancedFilters}
          isFilterCleared={isFilterCleared}
        />
      );
      break;
    case "SCOUT":
      content = (
        <ScoutFilter
          advancedFilters={advancedFilters as ScoutFilters}
          setAdvancedFilters={setAdvancedFilters}
          isFilterCleared={isFilterCleared}
        />
      );
      break;
    case "COACH":
      content = (
        <CoachFilter
          advancedFilters={advancedFilters as CoachFilters}
          setAdvancedFilters={setAdvancedFilters}
          isFilterCleared={isFilterCleared}
        />
      );
      break;
    case "AGENT":
      content = (
        <AgentFilter
          advancedFilters={advancedFilters as AgentFilters}
          setAdvancedFilters={setAdvancedFilters}
          isFilterCleared={isFilterCleared}
        />
      );
      break;
    case "OTHER":
      content = (
        <OtherFilter
          advancedFilters={advancedFilters as OtherFilters}
          setAdvancedFilters={setAdvancedFilters}
          isFilterCleared={isFilterCleared}
        />
      );
      break;
    default:
      content = <></>;
      break;
  }
  return (
    <>
      <Dialog
        open={openAdvancedSearch}
        onClose={() => {
          closeAdvancedSearch();
          setAdvancedFilters({});
        }}
        sx={{
          "& .MuiPaper-root": {
            margin: 0,
            borderRadius: "12px",
            overflow: "hidden",
            background: colors.white,
            height: "fit-content",
            maxHeight: "calc(100vh - 110px)",
            width: "90%",
            maxWidth: "670px",
          },
        }}
      >
        <DialogTitle
          sx={{
            padding: "18px",
            borderBottom: `1px solid #EAECF0`,
            textAlign: "center",
            ...typography.body14Regular,
            fontWeight: 700,
          }}
        >
          {t(`components.networkController.advancedFilterPopUp.${entityRole}AdvancedSearch`)}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            closeAdvancedSearch();
            setAdvancedFilters({});
          }}
          sx={{
            position: "absolute",
            left: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>{content}</DialogContent>
        <DialogActions
          sx={{
            borderTop: "1px solid #EAECF0",
            display: "flex",
            justifyContent: "space-between",
            padding: "15px 22px",
          }}
        >
          <Button
            variant="text-sm"
            sx={{
              width: "115px",
              fontFamily: "HeadingNowVarTrial",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
            }}
            onClick={clearFilter}
          >
            {t("components.networkController.advancedFilterPopUp.clearAll")}
          </Button>
          <Button
            variant="primary-sm"
            sx={{
              width: "115px",
              fontFamily: "HeadingNowVarTrial",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
            }}
            onClick={applyFilter}
          >
            {t("components.networkController.advancedFilterPopUp.filter")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdvancedSearch;
